var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecureLock = function SvgSecureLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "secure_lock__svg2__a",
    cx: 36.85,
    cy: 197.92,
    r: 187.02,
    fx: 36.85,
    fy: 197.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#secure_lock__svg2__a",
    id: "secure_lock__svg2__c",
    cx: 36.85,
    cy: 197.92,
    r: 187.02,
    fx: 36.85,
    fy: 197.92
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.4 79.54h-4.41V55.5c0-30.88-25.12-56-56-56s-56 25.12-56 56v24.04h-4.4c-8.01 0-14.53 6.52-14.53 14.53v90.91c0 8.01 6.52 14.53 14.53 14.53h120.8c8.01 0 14.53-6.52 14.53-14.53V94.07c0-8.01-6.52-14.53-14.53-14.53ZM50.77 55.5c0-27.15 22.09-49.23 49.23-49.23s49.23 22.09 49.23 49.23v24.04h-12.01V55.5c0-20.52-16.7-37.22-37.22-37.22S62.78 34.98 62.78 55.5v24.04H50.77zm18.77 24.04V55.5c0-16.8 13.66-30.46 30.46-30.46s30.46 13.66 30.46 30.46v24.04zm98.63 105.43c0 4.28-3.48 7.76-7.76 7.76H39.6c-4.28 0-7.76-3.48-7.76-7.76V94.06c0-4.28 3.48-7.76 7.76-7.76h120.8c4.28 0 7.76 3.48 7.76 7.76v90.91Z",
    style: {
      fill: "url(#secure_lock__svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.62 130.52c0-9.72-7.9-17.62-17.62-17.62s-17.62 7.9-17.62 17.62c0 5.23 2.3 10.1 6.25 13.42l-3.8 18.11c-.21 1 .04 2.04.68 2.83s1.61 1.25 2.62 1.25h23.73c1.02 0 1.98-.46 2.62-1.25s.89-1.83.68-2.83l-3.8-18.11a17.49 17.49 0 0 0 6.25-13.42Zm-11.82 9.14a3.38 3.38 0 0 0-1.49 3.55l3.39 16.16H92.3l3.39-16.16c.29-1.38-.31-2.79-1.49-3.55-3.17-2.02-5.06-5.43-5.06-9.14 0-5.99 4.87-10.86 10.86-10.86s10.86 4.87 10.86 10.86c0 3.71-1.89 7.13-5.06 9.14",
    style: {
      fill: "url(#secure_lock__svg2__c)",
      strokeWidth: 0
    }
  }));
};
export default SvgSecureLock;